import React from "react";
import { Grid, Paper, Typography, makeStyles } from "@material-ui/core";
import {
    Assignment as EventIcon,
    CheckCircle as DoneIcon,
    Warning as AlertIcon,
    Schedule as TimerIcon,
    Group as GroupIcon
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        height: 140,
        justifyContent: "space-between",
        borderLeft: "5px solid",
        position: "relative",
        overflow: "hidden" // For background icon effect
    },
    iconBg: {
        position: "absolute",
        right: -10,
        bottom: -10,
        opacity: 0.1,
        fontSize: 100
    }
}));

const KPICard = ({ title, value, color, icon: Icon, unit = "" }) => {
    const classes = useStyles();
    return (
        <Grid item xs={12} sm={6} md={3}>
            <Paper className={classes.paper} style={{ borderLeftColor: color }}>
                <Typography variant="h6" color="textSecondary">
                    {title}
                </Typography>
                <Typography variant="h3" style={{ color: color, fontWeight: "bold" }}>
                    {value} <span style={{ fontSize: "1rem", color: "#666" }}>{unit}</span>
                </Typography>
                {Icon && <Icon className={classes.iconBg} style={{ color: color }} />}
            </Paper>
        </Grid>
    );
};

const KPICards = ({ kpi }) => {
    return (
        <Grid container spacing={3}>
            {/* Line 1 - General */}
            <KPICard title="Total de Atendimentos" value={kpi.total} color="#4caf50" icon={EventIcon} />
            <KPICard title="Fechados" value={kpi.closed} color="#2196f3" icon={DoneIcon} />
            <KPICard title="Abertos" value={kpi.open} color="#ff9800" icon={AlertIcon} />
            <KPICard title="Pendentes" value={kpi.pending} color="#f44336" icon={TimerIcon} />

            {/* Line 2 - SLA & Quality */}
            <KPICard title="T.M. Espera" value={kpi.avgWaitTime} color="#673ab7" icon={TimerIcon} />
            <KPICard title="T.M. Atendimento" value={kpi.avgServiceTime} color="#7d12ce" icon={TimerIcon} />
            <KPICard title="Novos Contatos" value={kpi.newContacts} color="#e91e63" icon={GroupIcon} />
            <KPICard title="Atendentes Ativos" value={kpi.activeAgents} color="#009688" icon={GroupIcon} />
        </Grid>
    );
};

export default KPICards;
